import React from 'react';
import Input from "../../../components/ui/Input/Input";
import Button from "../../../components/ui/Button/Button";
import {useNewChatStore} from "../../../store";
import {Mars, Venus, ArrowRight} from 'lucide-react'
import LanguageSelect from "../../../components/ui/LanguageSelect/LanguageSelect";
import {ILanguage} from "../../../Models/ILanguage";
import StepAside from "../StepAside";

const genders: ("male" | "female")[] = ["male", "female"];

const Step1 = () => {

    const {setStep, currentStep, updateChatData, newChatData} = useNewChatStore();

    const changeChatName = (e: React.ChangeEvent<HTMLInputElement>) => {
        updateChatData({chat_name: e.target.value})
    }

    const isDisabled = () => {
        return !newChatData.chat_name.trim()
    }

    const selectTheApp = (gender: "male" | "female") => {
        updateChatData({chat_gender: gender})
    };

    const updateLanguage = (language: ILanguage) => {
        updateChatData({chat_language: language})
    }

    return (
        <div className="StepLayout">

            <div className="StepLayout__left">

                <span className="eyebrow">Step {currentStep} of 4</span>
                <h2>Who are you bringing back?</h2>
                <p className="StepLayout__description">Give the chat a name and tell us a bit about the person.</p>

                <div className="StepLayout__field">
                    <span className="StepLayout__label">Chat name</span>
                    <Input value={newChatData.chat_name} onChange={changeChatName} title={'e.g. Mom, Grandpa Joe'}
                           type={'text'} maxLength={40}/>
                </div>

                <div className="StepLayout__field">
                    <span className="StepLayout__label">Gender</span>
                    <div className="StepLayout__selector">
                        {
                            genders.map((el) => (
                                <button type="button" key={el} onClick={() => selectTheApp(el)}
                                        aria-pressed={newChatData.chat_gender === el}
                                        className={`StepLayout__selector_option ${newChatData.chat_gender === el ? 'active' : ''}`}>
                                    <span className={`icon-tile StepLayout__genderIcon StepLayout__genderIcon--${el}`}>
                                        {el === 'male' ? <Mars size={20}/> : <Venus size={20}/>}
                                    </span>
                                    <h3>{el === 'male' ? 'Male' : 'Female'}</h3>
                                    <div className='circle'/>
                                </button>
                            ))
                        }
                    </div>
                    <span className="StepLayout__hint">Used for grammar in languages with gendered words.</span>
                </div>

                <div className="StepLayout__field">
                    <span className="StepLayout__label">Reply language</span>
                    <LanguageSelect defaultLanguage={newChatData.chat_language?.code} onChange={updateLanguage}/>
                </div>

                <div className="StepLayout__buttons">
                    <span/>
                    <Button disabled={isDisabled()} onClick={() => setStep(currentStep + 1)} variant={'primary'}
                            type={'button'} title={'Continue'} icon={<ArrowRight size={16}/>}/>
                </div>

            </div>

            <StepAside title="Tip">
                Use the name you'd call them in real life, like "Mom" or "Max". You'll see it in your chat list.
            </StepAside>
        </div>
    );
};

export default Step1;
